import { render } from "./domian.vue?vue&type=template&id=619cf037&scoped=true"
import script from "./domian.vue?vue&type=script&lang=js"
export * from "./domian.vue?vue&type=script&lang=js"

import "./domian.vue?vue&type=style&index=0&id=619cf037&lang=less&scoped=true"

import exportComponent from "C:\\Sunshine\\code\\zydt\\独立部署版\\ywym\\ydd-zht-api\\h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-619cf037"]])

export default __exports__